import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BoardsService extends BaseApiService {
  // Optionally filter results by a calling-at location (NLC, CRS or description)
  getBoardsArrivals(location: string, callingAt?: string): Observable<any[]> {
    const params = callingAt ? { callingAt } : undefined;
    return this.get<any[]>(`/boards/arrivals/${location}`, params);
  }

  getBoardsDepartures(location: string, callingAt?: string): Observable<any[]> {
    const params = callingAt ? { callingAt } : undefined;
    return this.get<any[]>(`/boards/departures/${location}`, params);
  }
}
